var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$tools.isDefined(_vm.data))?_c('div',[_vm._t("default")],2):_c('div',[_c('v-progress-linear',{attrs:{"indeterminate":"","rounded":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }